<template>
  <div>
    <StepHeader
      title="What Is Your Budget?"
    />

    <StepContent
      width="md"
    >
      <AppButtonList
        :columns="2"
        :buttons="buttons"
        :value="car_budget"
        @input="handleClick($event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer
        :data-layer="[datalayerContinue, datalayerButtonList]"
        @click="$emit('next')"
      >
        Continue
      </AppButtonContinue>

      <StepTooltip>
        Find vehicle options that fit your budget.
      </StepTooltip>
    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepTooltip from '@/components/common/step/StepTooltip'

export default {
  // Name
  name: 'budget-select',

  // Components
  components: {
    AppButtonContinue,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader,
    StepTooltip
  },

  // Data
  data () {
    return {
      fieldName: 'car_budget',
      datalayerStepName: 'monthly_budget',
      defaultSelected: true,
      buttons: [{
        text: 'Under $300 / month',
        value: 'Under $300 / month',
        datalayer: 'under300'
      }, {
        text: '$300 - 399 / month',
        value: '$300 - 399 / month',
        datalayer: '300to399'
      }, {
        text: '$400 - 500 / month',
        value: '$400 - 500 / month',
        datalayer: '400to500'
      }, {
        text: 'Over $500 / month',
        value: '$501+ / month',
        datalayer: 'over500'
      }]
    }
  },

  // Computed
  computed: {
    car_budget () {
      return this.$store.state.application[this.fieldName]
    },

    datalayerContinue () {
      return `${this.datalayerStepName}_continue`
    },

    selectedButton () {
      if (!this.car_budget) return
      for (let i in this.buttons) {
        if (this.buttons[i].value === this.car_budget) {
          return this.buttons[i]
        }
      }
    },

    datalayerButtonList () {
      if (!this.selectedButton) return
      const datalayer = this.selectedButton.datalayer
      return `${this.datalayerStepName}_${datalayer}${this.defaultSelected ? '_default' : ''}`
    }
  },

  // Created
  created () {
    if (!this.car_budget) {
      this.$store.updateApplication(
        this.fieldName,
        this.buttons[0].value
      )
    } else {
      this.defaultSelected = false
    }
  },

  // Methods
  methods: {
    handleClick (event) {
      this.$store.updateApplication(this.fieldName, event)
      this.defaultSelected = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
